<template>
  <div class="window">
    <div class="bg" :style="{ filter: `opacity(${pageBgOpacity})` }">
      <div class="layer-0"></div>
      <div class="layer-1"></div>
      <div class="layer-2"></div>
      <div class="layer-3"></div>
    </div>
    <div class="layout">
      <Navigator v-show="$route.path !== '/index'" />
      <router-view class="nav-page" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Footer from '@/components/Footer.vue';
import Navigator from '@/components/Navigator';
import {
  getUserCenter
} from '@/api/system';
export default {
  name: 'Layout',
  components: {
    Footer,
    Navigator
  },
  computed: {
    pageBgOpacity() {
      const {
        meta
      } = this.$route

      return meta && meta.opacity ? meta.opacity : 1
    }
  },
  created() {
    this.getUserCenter()
  },
  methods: {
    ...mapActions(['setUserCenter']),
    getUserCenter(){
      getUserCenter().then((res) => {
        this.setUserCenter(res)
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .window {
    height: 100vh;
    width: 100vw;
    position: relative;
  }
  .bg {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 1;
    .layer-0 {
      width: 100%;
      height: 100px;
      background-image: linear-gradient(to bottom, #45D0C9, #3CBFD1);
    }
    .layer-1 {
      width: 100%;
      height: 174px;
      background-image: linear-gradient(to bottom, #3CBFD1, #2B76F6);
    }
    .layer-2 {
      width: 100%;
      height: 174px;
      background-image: linear-gradient(to bottom, #2B76F6, #427CFE);
    }
    .layer-3 {
      width: 100%;
      height: 1008px;
      background-image: linear-gradient(to bottom, #437CFE, #FDFDFD);
    }
  }
  .layout {
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    padding: 100px 0 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    z-index: 2;
    .nav-page {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
</style>